import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import isEmpty from 'lodash/isEmpty';
import SelectMultipleField from '../../../../../FormControl/input/SelectMultipleField';
import DialogConfirmCancel from '../../../../../dialog/DialogConfirm';
import InputField from '../../../../../FormControl/input/InputField';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilter, showFilter } from '../../../../../../store/actions/filter.actions';
import { updateSkip } from '../../../../../../store/actions/datatable.actions';
import { SelectFieldGender } from '../../../../../FormControl/SelectCustom/SelectFieldGender';
import { SelectMultipleFieldFlags } from '../../../../../FormControl/SelectRequest/SelectMultipleFieldFlags';
import { useLocation, useNavigate } from 'react-router-dom';

const FilterDialog = ({ dataYears = [], errorFetchYears, isLoadingYears }) => {
  const date = useSelector((state) => state?.date?.date || new Date());
  const filter = useSelector((state) => state?.filter.assessmentStudentsList?.filter || {});
  const open = useSelector((state) => state?.filter.assessmentStudentsList?.open || false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const yearsData = dataYears.map((item) => ({
    _id: item._id,
    name: item.name,
    code: item.code
  }));

  const dispatch = useDispatch();

  const [form, setInputForm] = useState(filter);
  const [error, setInputError] = useState({});

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter);
    }
  }, [filter]);

  const onClose = () => {
    dispatch(showFilter('assessmentStudentsList', false));
  };

  const onChange = (name, value) => {
    if (name === 'yearLevelId') {
      setInputError({ ...error, [name]: null, yearLevel: null });
      const yearLevel = yearsData.filter((item) => value.includes(item._id));
      setInputForm({ ...form, [name]: value, yearLevel });
    } else {
      setInputForm({ ...form, [name]: value });
      setInputError({ ...error, [name]: null });
    }
  };

  const onApply = () => {
    onClose()
    const filter = {
      ...form
    };

    dispatch(updateFilter('assessmentStudentsList', filter));
    dispatch(updateSkip('assessmentStudentsList', 0));
    navigate(pathname, { state: filter });
  };

  return (
    <DialogConfirmCancel
      id='builder-user-filter'
      open={open}
      title='Filter'
      maxWidth='xs'
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
    >
      <Box className='flex flex-col gap-4'>
        <div className='grid grid-cols-3 items-center gap-4'>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Code
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-code'
              name='code'
              value={form.code}
              error={error.code}
              helperText={error.code}
              maxDate={date}
              onChange={(e) => onChange('code', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            first name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-first-name'
              name='firstName'
              value={form.firstName}
              error={error.firstName}
              helperText={error.firstName}
              maxDate={date}
              onChange={(e) => onChange('firstName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            last name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-last-name'
              name='lastName'
              value={form.lastName}
              error={error.lastName}
              helperText={error.lastName}
              maxDate={date}
              onChange={(e) => onChange('lastName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            preferred name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-preferred-name'
              name='preferredName'
              value={form.preferredName}
              error={error.preferredName}
              helperText={error.preferredName}
              onChange={(e) => onChange('preferredName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            email
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-email'
              name='email'
              value={form.email}
              error={error.email}
              helperText={error.email}
              onChange={(e) => onChange('email', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            gender
          </Typography>
          <div className='col-span-2'>
            <SelectFieldGender
              id='form-filter-gender'
              name='gender'
              value={form.gender}
              error={error.gender}
              helperText={error.gender}
              onChange={(e) => onChange('gender', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            year level
          </Typography>
          <div className='col-span-2'>
            <SelectMultipleField
              id='form-filter-year-level'
              name='yearLevelId'
              value={form.yearLevelId}
              error={error.yearLevelId || errorFetchYears}
              helperText={error.yearLevelId || errorFetchYears}
              onChange={(e) => onChange('yearLevelId', e.target.value)}
              loading={isLoadingYears}
              options={yearsData?.map((item) => ({ value: item._id, label: item.name })) || []}
              placeholder='Choose a year level'
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            house
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-house'
              name='house'
              value={form.house}
              error={error.house}
              helperText={error.house}
              onChange={(e) => onChange('house', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            form
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-form'
              name='form'
              value={form.form}
              error={error.form}
              helperText={error.form}
              onChange={(e) => onChange('form', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            flag
          </Typography>
          <div className='col-span-2'>
            <SelectMultipleFieldFlags
              id='form-filter-flag'
              name='flag'
              value={form.flag}
              error={error.flag}
              helperText={error.flag}
              onChange={(e) => onChange('flag', e.target.value)}
              fieldValue='importName'
            />
          </div>
        </div>
      </Box>
    </DialogConfirmCancel>
  );
};

export default FilterDialog;
